import React from 'react';
import { Button, Form } from 'antd';
import { FormattedMessage } from 'react-intl';
import withLoading from 'Common/HOC/loadingOr';
import { Settings } from 'CoreApi.Settings_V12';
import BaseInformationForm from './BaseInformationForm';
import type { Address } from '../types';

interface Props {
  settings: Settings | undefined;
  saveSettings: (values: FormValues) => void;
  showPrevious?: boolean;
  goBack?: () => void;
}

export interface FormValues {
  country: string | null;
  shipping_address: Omit<Address, 'id' | 'title'>;
}

const getValidations = (s: FormValues) => ({
  companyNameValidated: Boolean(s?.shipping_address?.company),
  streetAddressValidated: Boolean(s?.shipping_address?.address1),
  cityValidated: Boolean(
    s?.shipping_address?.city && s?.shipping_address?.zipcode
  ),
});

const CheckStoreInformationForm: React.FC<Props> = (props) => {
  const handleUseBillingAddressClick = () => {
    if (props.settings?.billing_address) {
      props.saveSettings({
        ...props.settings,
        shipping_address: props.settings.billing_address,
      });
    }
  };

  return (
    <BaseInformationForm
      {...props}
      formName="shipping_address"
      getValidations={getValidations}
      additionalFields={
        <Form.Item>
          <Button onClick={() => handleUseBillingAddressClick()}>
            <FormattedMessage defaultMessage="Use billing address" />
          </Button>
        </Form.Item>
      }
    />
  );
};

export default withLoading<Props & { children: React.ReactNode }>(
  CheckStoreInformationForm
);
